import { createRouter, createWebHistory, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const req = require.context('./modules', false, /\.ts$/)

// 明确指定返回的路由模块类型为 RouteRecordRaw
const requireAll = (requireContext: __WebpackModuleApi.RequireContext): RouteRecordRaw[] =>
  requireContext.keys().map(requireContext as (key: string) => { default: RouteRecordRaw }).map(router => router.default)

const modules = requireAll(req)
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Index.vue')
  },
  // 将 modules 合并到 routes 数组中
  ...modules,
]

const router = createRouter({
  history: createWebHashHistory(), //createWebHashHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.matched.length == 0) return next({ path: '/404' })
  next()
})
router.afterEach((to, from) => { })
router.onError((error) => {
  // const targetPath = router.currentRoute.value.matched;
  try {
    if (process.env.NODE_ENV == 'development') {
    }
    localStorage.setItem('route_error', error.message)
  } catch (e) { }
  console.error('router.onError', error.message)
  // window.location.href = '/'
})
export default router

